export default {
    props: {
        navigatorCategoryAxisAutoBaseUnitStepsSeconds: {
            type: Array,
            kComposite: 'navigator.categoryAxis.autoBaseUnitSteps.seconds'
        }, 
        navigatorCategoryAxisAutoBaseUnitStepsMinutes: {
            type: Array,
            kComposite: 'navigator.categoryAxis.autoBaseUnitSteps.minutes'
        }, 
        navigatorCategoryAxisAutoBaseUnitStepsHours: {
            type: Array,
            kComposite: 'navigator.categoryAxis.autoBaseUnitSteps.hours'
        }, 
        navigatorCategoryAxisAutoBaseUnitStepsDays: {
            type: Array,
            kComposite: 'navigator.categoryAxis.autoBaseUnitSteps.days'
        }, 
        navigatorCategoryAxisAutoBaseUnitStepsWeeks: {
            type: Array,
            kComposite: 'navigator.categoryAxis.autoBaseUnitSteps.weeks'
        }, 
        navigatorCategoryAxisAutoBaseUnitStepsMonths: {
            type: Array,
            kComposite: 'navigator.categoryAxis.autoBaseUnitSteps.months'
        }, 
        navigatorCategoryAxisAutoBaseUnitStepsYears: {
            type: Array,
            kComposite: 'navigator.categoryAxis.autoBaseUnitSteps.years'
        }, 
        navigatorCategoryAxisAxisCrossingValue: {
            type: Object | Date | Array,
            kComposite: 'navigator.categoryAxis.axisCrossingValue'
        }, 
        navigatorCategoryAxisBackground: {
            type: String,
            kComposite: 'navigator.categoryAxis.background'
        }, 
        navigatorCategoryAxisBaseUnit: {
            type: String,
            kComposite: 'navigator.categoryAxis.baseUnit'
        }, 
        navigatorCategoryAxisBaseUnitStep: {
            type: Object,
            kComposite: 'navigator.categoryAxis.baseUnitStep'
        }, 
        navigatorCategoryAxisCategories: {
            type: Array,
            kComposite: 'navigator.categoryAxis.categories'
        }, 
        navigatorCategoryAxisColor: {
            type: String,
            kComposite: 'navigator.categoryAxis.color'
        }, 
        navigatorCategoryAxisCrosshairColor: {
            type: String,
            kComposite: 'navigator.categoryAxis.crosshair.color'
        }, 
        navigatorCategoryAxisCrosshairOpacity: {
            type: Number,
            kComposite: 'navigator.categoryAxis.crosshair.opacity'
        }, 
        navigatorCategoryAxisCrosshairTooltipBackground: {
            type: String,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.background'
        }, 
        navigatorCategoryAxisCrosshairTooltipBorderColor: {
            type: String,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.border.color'
        }, 
        navigatorCategoryAxisCrosshairTooltipBorderDashType: {
            type: String,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.border.dashType'
        }, 
        navigatorCategoryAxisCrosshairTooltipBorderWidth: {
            type: Number,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.border.width'
        }, 
        navigatorCategoryAxisCrosshairTooltipColor: {
            type: String,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.color'
        }, 
        navigatorCategoryAxisCrosshairTooltipFont: {
            type: String,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.font'
        }, 
        navigatorCategoryAxisCrosshairTooltipFormat: {
            type: String,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.format'
        }, 
        navigatorCategoryAxisCrosshairTooltipPadding: {
            type: Number,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.padding'
        }, 
        navigatorCategoryAxisCrosshairTooltipPaddingBottom: {
            type: Number,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.padding.bottom'
        }, 
        navigatorCategoryAxisCrosshairTooltipPaddingLeft: {
            type: Number,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.padding.left'
        }, 
        navigatorCategoryAxisCrosshairTooltipPaddingRight: {
            type: Number,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.padding.right'
        }, 
        navigatorCategoryAxisCrosshairTooltipPaddingTop: {
            type: Number,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.padding.top'
        }, 
        navigatorCategoryAxisCrosshairTooltipTemplate: {
            type: String | Function,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.template'
        }, 
        navigatorCategoryAxisCrosshairTooltipVisible: {
            type: Boolean,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.visible'
        }, 
        navigatorCategoryAxisCrosshairVisible: {
            type: Boolean,
            kComposite: 'navigator.categoryAxis.crosshair.visible'
        }, 
        navigatorCategoryAxisCrosshairWidth: {
            type: Number,
            kComposite: 'navigator.categoryAxis.crosshair.width'
        }, 
        navigatorCategoryAxisField: {
            type: String,
            kComposite: 'navigator.categoryAxis.field'
        }, 
        navigatorCategoryAxisJustified: {
            type: Boolean,
            kComposite: 'navigator.categoryAxis.justified'
        }, 
        navigatorCategoryAxisLabelsBackground: {
            type: String,
            kComposite: 'navigator.categoryAxis.labels.background'
        }, 
        navigatorCategoryAxisLabelsBorderColor: {
            type: String,
            kComposite: 'navigator.categoryAxis.labels.border.color'
        }, 
        navigatorCategoryAxisLabelsBorderDashType: {
            type: String,
            kComposite: 'navigator.categoryAxis.labels.border.dashType'
        }, 
        navigatorCategoryAxisLabelsBorderWidth: {
            type: Number,
            kComposite: 'navigator.categoryAxis.labels.border.width'
        }, 
        navigatorCategoryAxisLabelsColor: {
            type: String,
            kComposite: 'navigator.categoryAxis.labels.color'
        }, 
        navigatorCategoryAxisLabelsCulture: {
            type: String,
            kComposite: 'navigator.categoryAxis.labels.culture'
        }, 
        navigatorCategoryAxisLabelsDateFormatsDays: {
            type: String,
            kComposite: 'navigator.categoryAxis.labels.dateFormats.days'
        }, 
        navigatorCategoryAxisLabelsDateFormatsHours: {
            type: String,
            kComposite: 'navigator.categoryAxis.labels.dateFormats.hours'
        }, 
        navigatorCategoryAxisLabelsDateFormatsMonths: {
            type: String,
            kComposite: 'navigator.categoryAxis.labels.dateFormats.months'
        }, 
        navigatorCategoryAxisLabelsDateFormatsWeeks: {
            type: String,
            kComposite: 'navigator.categoryAxis.labels.dateFormats.weeks'
        }, 
        navigatorCategoryAxisLabelsDateFormatsYears: {
            type: String,
            kComposite: 'navigator.categoryAxis.labels.dateFormats.years'
        }, 
        navigatorCategoryAxisLabelsFont: {
            type: String,
            kComposite: 'navigator.categoryAxis.labels.font'
        }, 
        navigatorCategoryAxisLabelsFormat: {
            type: String,
            kComposite: 'navigator.categoryAxis.labels.format'
        }, 
        navigatorCategoryAxisLabelsMargin: {
            type: Number,
            kComposite: 'navigator.categoryAxis.labels.margin'
        }, 
        navigatorCategoryAxisLabelsMarginBottom: {
            type: Number,
            kComposite: 'navigator.categoryAxis.labels.margin.bottom'
        }, 
        navigatorCategoryAxisLabelsMarginLeft: {
            type: Number,
            kComposite: 'navigator.categoryAxis.labels.margin.left'
        }, 
        navigatorCategoryAxisLabelsMarginRight: {
            type: Number,
            kComposite: 'navigator.categoryAxis.labels.margin.right'
        }, 
        navigatorCategoryAxisLabelsMarginTop: {
            type: Number,
            kComposite: 'navigator.categoryAxis.labels.margin.top'
        }, 
        navigatorCategoryAxisLabelsMirror: {
            type: Boolean,
            kComposite: 'navigator.categoryAxis.labels.mirror'
        }, 
        navigatorCategoryAxisLabelsPadding: {
            type: Number,
            kComposite: 'navigator.categoryAxis.labels.padding'
        }, 
        navigatorCategoryAxisLabelsPaddingBottom: {
            type: Number,
            kComposite: 'navigator.categoryAxis.labels.padding.bottom'
        }, 
        navigatorCategoryAxisLabelsPaddingLeft: {
            type: Number,
            kComposite: 'navigator.categoryAxis.labels.padding.left'
        }, 
        navigatorCategoryAxisLabelsPaddingRight: {
            type: Number,
            kComposite: 'navigator.categoryAxis.labels.padding.right'
        }, 
        navigatorCategoryAxisLabelsPaddingTop: {
            type: Number,
            kComposite: 'navigator.categoryAxis.labels.padding.top'
        }, 
        navigatorCategoryAxisLabelsRotation: {
            type: Number | String,
            kComposite: 'navigator.categoryAxis.labels.rotation'
        }, 
        navigatorCategoryAxisLabelsSkip: {
            type: Number,
            kComposite: 'navigator.categoryAxis.labels.skip'
        }, 
        navigatorCategoryAxisLabelsStep: {
            type: Number,
            kComposite: 'navigator.categoryAxis.labels.step'
        }, 
        navigatorCategoryAxisLabelsTemplate: {
            type: String | Function,
            kComposite: 'navigator.categoryAxis.labels.template'
        }, 
        navigatorCategoryAxisLabelsVisible: {
            type: Boolean,
            kComposite: 'navigator.categoryAxis.labels.visible'
        }, 
        navigatorCategoryAxisLineColor: {
            type: String,
            kComposite: 'navigator.categoryAxis.line.color'
        }, 
        navigatorCategoryAxisLineDashType: {
            type: String,
            kComposite: 'navigator.categoryAxis.line.dashType'
        }, 
        navigatorCategoryAxisLineVisible: {
            type: Boolean,
            kComposite: 'navigator.categoryAxis.line.visible'
        }, 
        navigatorCategoryAxisLineWidth: {
            type: Number,
            kComposite: 'navigator.categoryAxis.line.width'
        }, 
        navigatorCategoryAxisMajorGridLinesColor: {
            type: String,
            kComposite: 'navigator.categoryAxis.majorGridLines.color'
        }, 
        navigatorCategoryAxisMajorGridLinesDashType: {
            type: String,
            kComposite: 'navigator.categoryAxis.majorGridLines.dashType'
        }, 
        navigatorCategoryAxisMajorGridLinesVisible: {
            type: Boolean,
            kComposite: 'navigator.categoryAxis.majorGridLines.visible'
        }, 
        navigatorCategoryAxisMajorGridLinesWidth: {
            type: Number,
            kComposite: 'navigator.categoryAxis.majorGridLines.width'
        }, 
        navigatorCategoryAxisMajorGridLinesStep: {
            type: Number,
            kComposite: 'navigator.categoryAxis.majorGridLines.step'
        }, 
        navigatorCategoryAxisMajorGridLinesSkip: {
            type: Number,
            kComposite: 'navigator.categoryAxis.majorGridLines.skip'
        }, 
        navigatorCategoryAxisMajorTicksColor: {
            type: String,
            kComposite: 'navigator.categoryAxis.majorTicks.color'
        }, 
        navigatorCategoryAxisMajorTicksSize: {
            type: Number,
            kComposite: 'navigator.categoryAxis.majorTicks.size'
        }, 
        navigatorCategoryAxisMajorTicksVisible: {
            type: Boolean,
            kComposite: 'navigator.categoryAxis.majorTicks.visible'
        }, 
        navigatorCategoryAxisMajorTicksWidth: {
            type: Number,
            kComposite: 'navigator.categoryAxis.majorTicks.width'
        }, 
        navigatorCategoryAxisMajorTicksStep: {
            type: Number,
            kComposite: 'navigator.categoryAxis.majorTicks.step'
        }, 
        navigatorCategoryAxisMajorTicksSkip: {
            type: Number,
            kComposite: 'navigator.categoryAxis.majorTicks.skip'
        }, 
        navigatorCategoryAxisMax: {
            type: Object,
            kComposite: 'navigator.categoryAxis.max'
        }, 
        navigatorCategoryAxisMaxDateGroups: {
            type: Number,
            kComposite: 'navigator.categoryAxis.maxDateGroups'
        }, 
        navigatorCategoryAxisMin: {
            type: Object,
            kComposite: 'navigator.categoryAxis.min'
        }, 
        navigatorCategoryAxisMinorGridLinesColor: {
            type: String,
            kComposite: 'navigator.categoryAxis.minorGridLines.color'
        }, 
        navigatorCategoryAxisMinorGridLinesDashType: {
            type: String,
            kComposite: 'navigator.categoryAxis.minorGridLines.dashType'
        }, 
        navigatorCategoryAxisMinorGridLinesVisible: {
            type: Boolean,
            kComposite: 'navigator.categoryAxis.minorGridLines.visible'
        }, 
        navigatorCategoryAxisMinorGridLinesWidth: {
            type: Number,
            kComposite: 'navigator.categoryAxis.minorGridLines.width'
        }, 
        navigatorCategoryAxisMinorGridLinesStep: {
            type: Number,
            kComposite: 'navigator.categoryAxis.minorGridLines.step'
        }, 
        navigatorCategoryAxisMinorGridLinesSkip: {
            type: Number,
            kComposite: 'navigator.categoryAxis.minorGridLines.skip'
        }, 
        navigatorCategoryAxisMinorTicksColor: {
            type: String,
            kComposite: 'navigator.categoryAxis.minorTicks.color'
        }, 
        navigatorCategoryAxisMinorTicksSize: {
            type: Number,
            kComposite: 'navigator.categoryAxis.minorTicks.size'
        }, 
        navigatorCategoryAxisMinorTicksVisible: {
            type: Boolean,
            kComposite: 'navigator.categoryAxis.minorTicks.visible'
        }, 
        navigatorCategoryAxisMinorTicksWidth: {
            type: Number,
            kComposite: 'navigator.categoryAxis.minorTicks.width'
        }, 
        navigatorCategoryAxisMinorTicksStep: {
            type: Number,
            kComposite: 'navigator.categoryAxis.minorTicks.step'
        }, 
        navigatorCategoryAxisMinorTicksSkip: {
            type: Number,
            kComposite: 'navigator.categoryAxis.minorTicks.skip'
        }, 
        navigatorCategoryAxisPlotBands: {
            type: Array,
            kComposite: 'navigator.categoryAxis.plotBands'
        },         navigatorCategoryAxisReverse: {
            type: Boolean,
            kComposite: 'navigator.categoryAxis.reverse'
        }, 
        navigatorCategoryAxisRoundToBaseUnit: {
            type: Boolean,
            kComposite: 'navigator.categoryAxis.roundToBaseUnit'
        }, 
        navigatorCategoryAxisTitleBackground: {
            type: String,
            kComposite: 'navigator.categoryAxis.title.background'
        }, 
        navigatorCategoryAxisTitleBorderColor: {
            type: String,
            kComposite: 'navigator.categoryAxis.title.border.color'
        }, 
        navigatorCategoryAxisTitleBorderDashType: {
            type: String,
            kComposite: 'navigator.categoryAxis.title.border.dashType'
        }, 
        navigatorCategoryAxisTitleBorderWidth: {
            type: Number,
            kComposite: 'navigator.categoryAxis.title.border.width'
        }, 
        navigatorCategoryAxisTitleColor: {
            type: String,
            kComposite: 'navigator.categoryAxis.title.color'
        }, 
        navigatorCategoryAxisTitleFont: {
            type: String,
            kComposite: 'navigator.categoryAxis.title.font'
        }, 
        navigatorCategoryAxisTitleMargin: {
            type: Number,
            kComposite: 'navigator.categoryAxis.title.margin'
        }, 
        navigatorCategoryAxisTitleMarginBottom: {
            type: Number,
            kComposite: 'navigator.categoryAxis.title.margin.bottom'
        }, 
        navigatorCategoryAxisTitleMarginLeft: {
            type: Number,
            kComposite: 'navigator.categoryAxis.title.margin.left'
        }, 
        navigatorCategoryAxisTitleMarginRight: {
            type: Number,
            kComposite: 'navigator.categoryAxis.title.margin.right'
        }, 
        navigatorCategoryAxisTitleMarginTop: {
            type: Number,
            kComposite: 'navigator.categoryAxis.title.margin.top'
        }, 
        navigatorCategoryAxisTitlePadding: {
            type: Number,
            kComposite: 'navigator.categoryAxis.title.padding'
        }, 
        navigatorCategoryAxisTitlePaddingBottom: {
            type: Number,
            kComposite: 'navigator.categoryAxis.title.padding.bottom'
        }, 
        navigatorCategoryAxisTitlePaddingLeft: {
            type: Number,
            kComposite: 'navigator.categoryAxis.title.padding.left'
        }, 
        navigatorCategoryAxisTitlePaddingRight: {
            type: Number,
            kComposite: 'navigator.categoryAxis.title.padding.right'
        }, 
        navigatorCategoryAxisTitlePaddingTop: {
            type: Number,
            kComposite: 'navigator.categoryAxis.title.padding.top'
        }, 
        navigatorCategoryAxisTitlePosition: {
            type: String,
            kComposite: 'navigator.categoryAxis.title.position'
        }, 
        navigatorCategoryAxisTitleRotation: {
            type: Number,
            kComposite: 'navigator.categoryAxis.title.rotation'
        }, 
        navigatorCategoryAxisTitleText: {
            type: String,
            kComposite: 'navigator.categoryAxis.title.text'
        }, 
        navigatorCategoryAxisTitleVisible: {
            type: Boolean,
            kComposite: 'navigator.categoryAxis.title.visible'
        }, 
        navigatorCategoryAxisVisible: {
            type: Boolean,
            kComposite: 'navigator.categoryAxis.visible'
        }, 
        navigatorCategoryAxisWeekStartDay: {
            type: Number,
            kComposite: 'navigator.categoryAxis.weekStartDay'
        }, 
        navigatorCategoryAxisNotesPosition: {
            type: String,
            kComposite: 'navigator.categoryAxis.notes.position'
        }, 
        navigatorCategoryAxisNotesIconBackground: {
            type: String,
            kComposite: 'navigator.categoryAxis.notes.icon.background'
        }, 
        navigatorCategoryAxisNotesIconBorderColor: {
            type: String,
            kComposite: 'navigator.categoryAxis.notes.icon.border.color'
        }, 
        navigatorCategoryAxisNotesIconBorderWidth: {
            type: Number,
            kComposite: 'navigator.categoryAxis.notes.icon.border.width'
        }, 
        navigatorCategoryAxisNotesIconSize: {
            type: Number,
            kComposite: 'navigator.categoryAxis.notes.icon.size'
        }, 
        navigatorCategoryAxisNotesIconType: {
            type: String,
            kComposite: 'navigator.categoryAxis.notes.icon.type'
        }, 
        navigatorCategoryAxisNotesIconVisible: {
            type: Boolean,
            kComposite: 'navigator.categoryAxis.notes.icon.visible'
        }, 
        navigatorCategoryAxisNotesLabelBackground: {
            type: String,
            kComposite: 'navigator.categoryAxis.notes.label.background'
        }, 
        navigatorCategoryAxisNotesLabelBorderColor: {
            type: String,
            kComposite: 'navigator.categoryAxis.notes.label.border.color'
        }, 
        navigatorCategoryAxisNotesLabelBorderDashType: {
            type: String,
            kComposite: 'navigator.categoryAxis.notes.label.border.dashType'
        }, 
        navigatorCategoryAxisNotesLabelBorderWidth: {
            type: Number,
            kComposite: 'navigator.categoryAxis.notes.label.border.width'
        }, 
        navigatorCategoryAxisNotesLabelColor: {
            type: String,
            kComposite: 'navigator.categoryAxis.notes.label.color'
        }, 
        navigatorCategoryAxisNotesLabelFont: {
            type: String,
            kComposite: 'navigator.categoryAxis.notes.label.font'
        }, 
        navigatorCategoryAxisNotesLabelTemplate: {
            type: String | Function,
            kComposite: 'navigator.categoryAxis.notes.label.template'
        }, 
        navigatorCategoryAxisNotesLabelVisible: {
            type: Boolean,
            kComposite: 'navigator.categoryAxis.notes.label.visible'
        }, 
        navigatorCategoryAxisNotesLabelRotation: {
            type: Number,
            kComposite: 'navigator.categoryAxis.notes.label.rotation'
        }, 
        navigatorCategoryAxisNotesLabelFormat: {
            type: String,
            kComposite: 'navigator.categoryAxis.notes.label.format'
        }, 
        navigatorCategoryAxisNotesLabelPosition: {
            type: String,
            kComposite: 'navigator.categoryAxis.notes.label.position'
        }, 
        navigatorCategoryAxisNotesLineWidth: {
            type: Number,
            kComposite: 'navigator.categoryAxis.notes.line.width'
        }, 
        navigatorCategoryAxisNotesLineColor: {
            type: String,
            kComposite: 'navigator.categoryAxis.notes.line.color'
        }, 
        navigatorCategoryAxisNotesLineLength: {
            type: Number,
            kComposite: 'navigator.categoryAxis.notes.line.length'
        }, 
        navigatorCategoryAxisNotesData: {
            type: Array,
            kComposite: 'navigator.categoryAxis.notes.data'
        },         navigatorDataSource: {
            type: Object,
            kComposite: 'navigator.dataSource'
        }, 
        navigatorAutoBind: {
            type: Boolean,
            kComposite: 'navigator.autoBind'
        }, 
        navigatorDateField: {
            type: String,
            kComposite: 'navigator.dateField'
        }, 
        navigatorPaneBackground: {
            type: String,
            kComposite: 'navigator.pane.background'
        }, 
        navigatorPaneBorderColor: {
            type: String,
            kComposite: 'navigator.pane.border.color'
        }, 
        navigatorPaneBorderDashType: {
            type: String,
            kComposite: 'navigator.pane.border.dashType'
        }, 
        navigatorPaneBorderWidth: {
            type: Number,
            kComposite: 'navigator.pane.border.width'
        }, 
        navigatorPaneHeight: {
            type: Number,
            kComposite: 'navigator.pane.height'
        }, 
        navigatorPaneMargin: {
            type: Number,
            kComposite: 'navigator.pane.margin'
        }, 
        navigatorPaneMarginBottom: {
            type: Number,
            kComposite: 'navigator.pane.margin.bottom'
        }, 
        navigatorPaneMarginLeft: {
            type: Number,
            kComposite: 'navigator.pane.margin.left'
        }, 
        navigatorPaneMarginRight: {
            type: Number,
            kComposite: 'navigator.pane.margin.right'
        }, 
        navigatorPaneMarginTop: {
            type: Number,
            kComposite: 'navigator.pane.margin.top'
        }, 
        navigatorPaneName: {
            type: String,
            kComposite: 'navigator.pane.name'
        }, 
        navigatorPanePadding: {
            type: Number,
            kComposite: 'navigator.pane.padding'
        }, 
        navigatorPanePaddingBottom: {
            type: Number,
            kComposite: 'navigator.pane.padding.bottom'
        }, 
        navigatorPanePaddingLeft: {
            type: Number,
            kComposite: 'navigator.pane.padding.left'
        }, 
        navigatorPanePaddingRight: {
            type: Number,
            kComposite: 'navigator.pane.padding.right'
        }, 
        navigatorPanePaddingTop: {
            type: Number,
            kComposite: 'navigator.pane.padding.top'
        }, 
        navigatorPaneTitle: {
            type: String,
            kComposite: 'navigator.pane.title'
        }, 
        navigatorPaneTitleBackground: {
            type: String,
            kComposite: 'navigator.pane.title.background'
        }, 
        navigatorPaneTitleBorderColor: {
            type: String,
            kComposite: 'navigator.pane.title.border.color'
        }, 
        navigatorPaneTitleBorderDashType: {
            type: String,
            kComposite: 'navigator.pane.title.border.dashType'
        }, 
        navigatorPaneTitleBorderWidth: {
            type: Number,
            kComposite: 'navigator.pane.title.border.width'
        }, 
        navigatorPaneTitleColor: {
            type: String,
            kComposite: 'navigator.pane.title.color'
        }, 
        navigatorPaneTitleFont: {
            type: String,
            kComposite: 'navigator.pane.title.font'
        }, 
        navigatorPaneTitleMargin: {
            type: Number,
            kComposite: 'navigator.pane.title.margin'
        }, 
        navigatorPaneTitleMarginBottom: {
            type: Number,
            kComposite: 'navigator.pane.title.margin.bottom'
        }, 
        navigatorPaneTitleMarginLeft: {
            type: Number,
            kComposite: 'navigator.pane.title.margin.left'
        }, 
        navigatorPaneTitleMarginRight: {
            type: Number,
            kComposite: 'navigator.pane.title.margin.right'
        }, 
        navigatorPaneTitleMarginTop: {
            type: Number,
            kComposite: 'navigator.pane.title.margin.top'
        }, 
        navigatorPaneTitlePosition: {
            type: String,
            kComposite: 'navigator.pane.title.position'
        }, 
        navigatorPaneTitleText: {
            type: String,
            kComposite: 'navigator.pane.title.text'
        }, 
        navigatorPaneTitleVisible: {
            type: Boolean,
            kComposite: 'navigator.pane.title.visible'
        }, 
        navigatorVisible: {
            type: Boolean,
            kComposite: 'navigator.visible'
        }, 
        navigatorSeries: {
            type: Array | Object,
            kComposite: 'navigator.series'
        },
        navigatorSelectFrom: {
            type: Date | String,
            kComposite: 'navigator.select.from'
        }, 
        navigatorSelectMousewheel: {
            type: Boolean,
            kComposite: 'navigator.select.mousewheel'
        }, 
        navigatorSelectMousewheelReverse: {
            type: Boolean,
            kComposite: 'navigator.select.mousewheel.reverse'
        }, 
        navigatorSelectMousewheelZoom: {
            type: String,
            kComposite: 'navigator.select.mousewheel.zoom'
        }, 
        navigatorSelectTo: {
            type: Date | String,
            kComposite: 'navigator.select.to'
        }, 
        navigatorHintVisible: {
            type: Boolean,
            kComposite: 'navigator.hint.visible'
        }, 
        navigatorHintTemplate: {
            type: String | Function,
            kComposite: 'navigator.hint.template'
        }, 
        navigatorHintFormat: {
            type: String,
            kComposite: 'navigator.hint.format'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoStockChart/Navigator.js